<template>
	<div class="service w1400">
		<div class="ser-header font20">
			当前位置：新能源监管 > 物流企业登录
		</div>
		<div class="ser-cont">
        <div v-for="item in tab" class="tab" @click="navtonav(item)">
          <img :src="item.icon" alt="">
          <div class="font20 tabbom">{{item.name}}</div>
        </div>
		</div>
	</div>
</template>

<script>
  export default{
    data(){
      return{
        tab:[
          {
            icon:require("../../assets/1.png"),
            name:'物流公司车辆申报',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon:require("../../assets/2.png"),
            name:'物流公司货物申报',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon:require("../../assets/3.png"),
            name:'物流公司补贴申请',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon:require("../../assets/4.png"),
            name:'通行证申请/发放',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon:require("../../assets/5.png"),
            name:'意见建议',
            path:'/suggestion'
          },
          {
            icon:require("../../assets/5.png"),
            name:'投诉反馈',
            path:'/complaints'
          },
          ]
      }
    },
    methods:{
      navtonav(item){
        if(item.path){
          this.$router.push({path:item.path})
        }else{
          // window.open(item.url,'_blank')
          location.href = item.url;
        }
      }
    }
  }
</script>

<style scoped>
  .ser-header{
    box-sizing: border-box;
    width: 100%;
    height: 7rem;
    line-height: 7rem;
    padding-left: 2.7rem;
    background-color: #F6F5F5;
  }
  .ser-cont{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 100%;
    margin-top: 2.4rem;
  }
  .tab{
    width: 43rem;
    text-align: center;
    margin-bottom: 4.8rem;
  }
  .tab>img{
    display: block;
    width: 43rem;
    height: 28.2rem;
  }
  .tabbom{
    height: 9.2rem;
    line-height: 9.2rem;
    border-radius:0 0 0.4rem 0.4rem;
    border-bottom:1px solid #DCDCDC;
    border-left:1px solid #DCDCDC;
    border-right:1px solid #DCDCDC;

  }
</style>



// WEBPACK FOOTER //
// src/components/page/services.vue